import type { BitBaseEvent } from './bit-base-event';

export type Callback = (event: BitBaseEvent<any>) => void;
